// extracted by mini-css-extract-plugin
export default {"container":"ge","overlay":"he","videoOverlay":"ie","withHeader":"je","header":"ke","close":"le","content":"me"};